import { jsx } from "react/jsx-runtime";
import LockIcon from "@mui/icons-material/Lock";
import { validateTidalLicense } from "../../base/index.js";
function Lock(props) {
  return /* @__PURE__ */ jsx(
    LockIcon,
    {
      "data-testid": "Lock",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Lock",
      "data-tidal-icon-meta": "fileActions"
    }
  );
}
Lock.tidalIconMeta = {
  categories: "fileActions",
  name: "Lock"
};
validateTidalLicense();
export {
  Lock
};
//# sourceMappingURL=Lock.js.map
